import { render, staticRenderFns } from "./SetStatusWidget.vue?vue&type=template&id=5a364e73"
import script from "./SetStatusWidget.vue?vue&type=script&lang=js"
export * from "./SetStatusWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports